/**
 * Who the cheques were written to.
 *
 * A payee is free text on the LD-203 and carries no identifier of its own,
 * so somewhere to send the reader has to be earned from the rows underneath
 * it. Two kinds can be, and they are not the same kind of link.
 *
 * A party committee **is** the thing its page is about, so the name is the
 * link. A campaign committee is not: "REPUBLICAN PARTY OF KENTUCKY" resolves
 * to Mitch McConnell and is emphatically not his own committee, which is the
 * point this section's subtitle makes. Renaming it after him, or linking his
 * page from his name, would undo that. So the filed name stays exactly as
 * filed and the member is named separately, as who it was filed for.
 *
 * The remaining sixth — embassies, inaugural committees, state parties —
 * have nowhere to go, and are left as text rather than pointed somewhere
 * approximate.
 */

import { Link } from "react-router-dom";
import type { FirmDetail } from "../api";
import { brief } from "./party";

export function Payees({ rows }: { rows: FirmDetail["payees"] }) {
  return (
    <ol className="mt-3 divide-y divide-line rounded-2xl border border-line bg-card">
      {rows.map((row) => (
        <li key={row.payee} className="flex items-baseline gap-3 px-4 py-2.5 text-sm">
          <span className="w-16 font-medium tabular-nums">{brief(row.amount)}</span>
          <span className="flex-1">
            {row.committee_id ? (
              <Link
                to={`/money/committees/${row.committee_id}`}
                className="font-medium hover:text-brand hover:underline"
              >
                {row.payee}
              </Link>
            ) : (
              row.payee
            )}
            {!row.committee_id && row.bioguide && (
              <span className="text-faint">
                {" · for "}
                <Link
                  to={`/member/${row.bioguide}`}
                  className="text-muted hover:text-brand hover:underline"
                >
                  {row.full_name}
                </Link>
              </span>
            )}
          </span>
          <span className="text-faint">{row.gifts.toLocaleString()}</span>
        </li>
      ))}
    </ol>
  );
}
